import {Url} from '@/utils/url';
import axios from 'axios';
import get from 'lodash/get';

const DownloadBackordersApi = {
  getDefaultExportOptions() {
    return {
      hideUnallocated: false,
      hideLinesWithoutComments: false,
      showSoldOut: false,
      showProjectOne: false,
      hideWarranties: false,
      hidePreseason: false,
      skuSearchTerm: null,
      orderNumberSearchTerm: null,
      customerPoSearchTerm: null,
      type: 'bike',
      sortBy: 'allocated',
    };
  },

  /**
   * Obtain ID of export request.
   * @return {Promise<string>}
   */
  async obtainExportId(options) {
    const params = Object.assign(this.getDefaultExportOptions(), options);
    const requestUrl = Url.create('/allocated/items/export', params);
    const exportId = get(await axios.get(requestUrl), 'data.data', '');

    if (!exportId || !exportId.length) {
      throw new Error('Export ID is empty.');
    }

    return exportId;
  },

  /**
   * Checks export status and returns whether the exported file is ready to be downloaded or not.
   * @param exportId
   * @return {Promise<boolean>}
   */
  async isFileReady(exportId) {
    const requestUrl = `/allocated/items/export/status/${exportId}/`;
    return get(await axios.get(requestUrl), 'data.data') === 'Completed';
  },

  /**
   * Get URL to download the file by export ID.
   * @param exportId
   * @return {string}
   */
  getFileDownloadUrl(exportId) {
    return Url.withContextPath(`/allocated/items/export/${exportId}/`);
  },
};

export {DownloadBackordersApi};
